import { render } from "./ACPDashboard.vue?vue&type=template&id=ae26855c"
import script from "./ACPDashboard.vue?vue&type=script&lang=js"
export * from "./ACPDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__